import axios, { AxiosResponse } from 'axios';
import { matchesUrl, searchUrl } from 'findem-helpers';

const IcpAPI = {
  fetchProfilesByPrId: async (payload: { joid: string; prids: string[] }): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/profile`, {
      type: 'Profiles',
      prids: payload.prids,
      joid: payload.joid,
      detail: 'true',
      bust_cache: true
    }, { withCredentials: true });
  },

  fetchProfileNotesByPrIds: async (payload: { joid: string; prids: string[] }): Promise<AxiosResponse<any>> => {
    return axios.post(`${matchesUrl}/hm/api/fetch/notes`, {
      prids: payload.prids,
      joid: payload.joid
    }, { withCredentials: true });
  },

  fetchProfilesByCandidateRef: async (payload: { joid: string; prids: string[] }): Promise<AxiosResponse<any>> => {
    return axios.post(`${matchesUrl}/hm/api/profile/profile-by-candidate-ref`, {
      only_linkedin_ext_refs: false,
      prefer_current_exp: false,
      prefer_sandbox: false,
      joid: payload.joid,
      prids: payload.prids,
      proj: {
        'candidate.linkedin': 1,
        ref: 1
      }
    }, {
      params: { joid: payload.joid },
      withCredentials: true
    });
  },
};

export default IcpAPI;
